<mat-card-content class="p-0 m-b-10">
    <div class="row justify-content-between gap-16">
        <div class="col-lg-4">
            <mat-form-field appearance="outline" class="w-100 hide-hint">
                <input matInput placeholder="Search {{ 'ENTITY.DRUG' | translate }}" [formControl]="searchdrug">
                <mat-icon matSuffix>
                    <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
                </mat-icon>
            </mat-form-field>
        </div>
        <div class="col-lg-4 d-flex align-items-center justify-content-end">
            <button mat-flat-button color="primary" (click)="onAddDrug()">
                <mat-icon>add</mat-icon>
                {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.DRUG' | translate }}
            </button>
        </div>
    </div>
</mat-card-content>
<mat-card>
    <mat-card-content class="p-0">
        <div class="table-responsive table-scroll-container">
            <table mat-table [dataSource]="dataSource" class="w-100">

                <ng-container matColumnDef="drugName">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.DRUG_NAME' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{ element.name }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="genericName">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.GENERIC_NAME' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{ element.genericName | defaultValue }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="genericContent">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.GENERIC_CONTENT' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14 ellipsis-text">
                        <ng-container *ngFor="let g of element.genericContents; let last = last">
                            {{ g.name | defaultValue }}<span *ngIf="!last">, </span>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="drugCompanyName">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.DRUG_COMPANY' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{ element.drugCompanyName | defaultValue}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="drugTypeName">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.DRUG_TYPE' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{ element.drugTypeName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="instructions">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.INSTRUCTIONS' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14 ellipsis-text">
                        {{ element.instructions | defaultValue }}
                    </td>
                </ng-container>


                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.ACTION_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="action-link">
                        <a class="m-r-10 cursor-pointer" (click)="onUpdateDrug(element)"><i-tabler name="edit"
                                class="icon-18"></i-tabler></a>
                        <a class="m-r-10 cursor-pointer" (click)="onDeleteDrug(element.id)">
                            <i-tabler name="trash" class="icon-18"></i-tabler>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <div *ngIf="dataSource.data.length===0">
                <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
            </div>
            <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}"
                [length]="pagination.rowCount" [pageSize]="pagination.pageSize" [pageSizeOptions]="pageSizeOptions"
                [showFirstLastButtons]="true" [pageIndex]="pagination.currentPage">

            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>